import {addDefaultUserGroup} from "../util/groupUtils";

export function applyDataToAssignedUsersEditor(editor, {
    users,
    userGroups,
    timeZoneGroups,
    userGroupsEnabled,
    timeZoneGroupsEnabled,
    canModifyAny
}) {
    const userGroupsWithDefault = (userGroups) ? addDefaultUserGroup(userGroups) : userGroups
    editor.setState({
        users,
        userGroups: userGroupsWithDefault,
        timeZoneGroups,
        userGroupsEnabled,
        timeZoneGroupsEnabled,
        canModifyAny,
        loading: false
    })
}

export function applyActionResultToAssignedUsersEditor(editor, actionResult) {
    editor.setState({loading: true});

    return actionResult
            .then(data => {
                applyDataToAssignedUsersEditor(editor, data);
            })
            .catch(e => {
                editor.setState({loading: false})
                throw e
            })
}


// WEBPACK FOOTER //
// ./web/js/panels/applyAction.js